const COLORS = ['#6B7A5A', '#B89E7E', '#8A9B6F', '#C9B896', '#A4947E', '#7a6552'];

export interface EOAvatarProps {
  name: string;
  sm?: boolean;
}

export function EOAvatar({ name, sm }: EOAvatarProps) {
  const idx = (name || '?').charCodeAt(0) % COLORS.length;
  const initials = (name || '?')
    .split(/\s+/)
    .map((s) => s[0])
    .join('')
    .slice(0, 2)
    .toUpperCase();
  const size = sm ? 22 : 32;
  const fontSize = sm ? 10 : 11;

  return (
    <span
      className={sm ? 'avatar-sm' : 'avatar'}
      style={{
        background: COLORS[idx],
        color: '#fff',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: '999px',
        width: size,
        height: size,
        fontFamily: 'var(--font-sans)',
        fontWeight: 700,
        fontSize,
      }}
    >
      {initials}
    </span>
  );
}
